/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, {Component, PropTypes} from 'react';
import {
  FormGroup,
  Input,
  Label,
  Button,
  Col,
  Modal,
  ModalHeader,
  Container,
  ModalFooter
} from 'src/components/Common/reactstrap/lib';

class ModalChangePassword extends React.Component {
  //TODO: check empty old password
  //TODO: onblur check old password on server
  //TODO: check empty new password
  //TODO: check compare new password fields
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      password: null,
      newPassword: null,
      isNewPasswordValid: true,
      newPasswordValidStyle: ''
    };

    this.toggle = this.toggle.bind(this);
    this.passwordChange = this.passwordChange.bind(this);
    this.newPasswordChange = this.newPasswordChange.bind(this);
    this.newPasswordValidate = this.newPasswordValidate.bind(this);
    this.submitChange = this.submitChange.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  submitChange() {
    const {modal, password, newPassword, isNewPasswordValid} = this.state;
    const isDataValid = !!password && !!newPassword;

    if (isDataValid && isNewPasswordValid) {
      this.props.onChangePassword(password, newPassword)
        .then(() => this.setState({modal: !modal}))
        .catch((err) => alert(err)); //TODO: need correct exception handling
    }
    else if (!isDataValid) {
      alert('Пустые поля не заполнены!'); //todo: need remove this
    }
  }

  passwordChange(e) {
    this.setState({
      password: e.target.value
    });
  }

  newPasswordValidate(e) {

    const isNewPasswordValid = this.state.newPassword == e.target.value;
    const newPasswordValidStyle = isNewPasswordValid ? '' : 'danger';

    this.setState({
      isNewPasswordValid,
      newPasswordValidStyle
    });
  }

  newPasswordChange(e) {

    this.setState({
      newPassword: e.target.value
    });
  }

  render() {
    return (
      <FormGroup row>
        <Label sm={3}>Смена пароля</Label>
        <Col sm={9}>
          <Button onClick={this.toggle}>Сменить пароль</Button>
        </Col>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader toggle={this.toggle}>Смена пароля</ModalHeader>
          <Container>
            <Col sm={7}>
              <Input type="password" placeholder="Введите старый пароль" onChange={this.passwordChange}/>
              <Input type="password" placeholder="Новый пароль" onChange={this.newPasswordChange}/>
              <Input type="password" placeholder="Повторите новый пароль" state={this.state.newPasswordValidStyle}
                     onChange={this.newPasswordValidate}/>
            </Col>
          </Container>
          <ModalFooter>
            <Col sm={7}>
              <div>
                <Button className="btn-wide" onClick={this.submitChange}>Сменить пароль</Button>
              </div>
            </Col>
          </ModalFooter>
        </Modal>
      </FormGroup>
    );
  }
}

ModalChangePassword.propTypes = {
  isOpen: PropTypes.bool,

  toggle: PropTypes.func,

  size: PropTypes.string,

  backdrop: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(['static'])
  ]),
  keyboard: PropTypes.bool,

  zIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default ModalChangePassword;



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/ModalChangePassword.jsx
 **/